import { toSentenceCase } from 'src/utils/format-string';

// Keys copied from reffie/models/property_fact.py :: PropertyFactKey
export const PROPERTY_FACT_KEYS = [
    'policy_document_link',
    'pet_policy',
    'listing_links',
    'website',
    'min_income_multiple',
    'is_furnished',
    'income_requirements',
    'tour_times',
    'is_affordable_housing',
    'onsite_team',
    'affordable_housing_income_chart_link',
    'tour_parking',
    'resident_parking',
    'application_policy',
    'voucher_policy',
    'canonical_rent_source',
    'occupancy_rules',
    'age_restrictions',
    'move_in_specials',
    'ami_income_limits',
    'absolute_income_limit',
    'tour_scheduling_requirements',
    'guest_parking',
    'has_virtual_tours',
] as const;

export type PropertyFactKey = typeof PROPERTY_FACT_KEYS[number];

// Keys whose value is a JSON boolean rather than free text. The backend reads these
// strictly — a string "yes" reads as unset — so they get a Yes/No picker.
export const BOOLEAN_PROPERTY_FACT_KEYS = new Set<PropertyFactKey>([
    'has_virtual_tours',
]);

export function isBooleanFactKey(key: PropertyFactKey | ''): boolean {
    return key !== '' && BOOLEAN_PROPERTY_FACT_KEYS.has(key);
}

// Keys whose value is structured JSON rather than free text. The facts editor has no
// input for them, so they must not be offered in the add-fact key dropdown.
export const HIDDEN_PROPERTY_FACT_KEYS = new Set<PropertyFactKey>([
    'ami_income_limits',
]);

export function isHiddenFactKey(key: PropertyFactKey | ''): boolean {
    return key !== '' && HIDDEN_PROPERTY_FACT_KEYS.has(key);
}

// Keys whose value is a list of strings. One fact still holds them all — property_facts
// is unique on (property_id, key) — so the editor shows one row with several inputs.
export const MULTI_VALUE_PROPERTY_FACT_KEYS = new Set<PropertyFactKey>([
    'listing_links',
]);

export function isMultiValueFactKey(key: PropertyFactKey | ''): boolean {
    return key !== '' && MULTI_VALUE_PROPERTY_FACT_KEYS.has(key);
}

export const PROPERTY_FACT_KEY_LABELS: Record<PropertyFactKey, string> = PROPERTY_FACT_KEYS.reduce<Record<PropertyFactKey, string>>((acc, v: PropertyFactKey) => {
    // hide the "is_"/"has_" prefix
    let label = v as string;
    if (v.startsWith('is_')) {
        label = v.substring(3);
    } else if (v.startsWith('has_')) {
        label = v.substring(4);
    }

    acc[v] = toSentenceCase(label.replace(/_/g, ' '));
    return acc;
}, {} as Record<PropertyFactKey, string>);